<template>
  <div>
    <v-dialog
      v-model="show"
      persistent
      max-width="700px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      scrollable
    >
      <v-form ref="form" v-model="valid">
        <v-card elevation="24">
          <v-toolbar dark color="primary" elevation="0">
            <v-icon large class="mr-2">mdi-account-edit</v-icon>
            <v-toolbar-title class="text-h5">Datos del Jugador</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="show = false" :disabled="guardando">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-progress-linear
            v-if="guardando"
            indeterminate
            color="success"
            class="mb-0"
          ></v-progress-linear>

          <v-card-text class="pt-6 pb-4">
            <v-alert color="success" outlined dense class="mb-6" prominent>
              <v-row align="center">
                <v-col>
                  <div class="text-subtitle-1 font-weight-bold">
                    <v-icon left color="success">mdi-calendar-check</v-icon>
                    Turno seleccionado
                  </div>
                  <div class="mt-2">
                    <v-chip small color="primary" dark class="mr-2">
                      <v-icon left small>mdi-calendar</v-icon>
                      {{ turnoSeleccionado?.fechaTurnoString }}
                    </v-chip>
                    <v-chip small color="success" dark>
                      <v-icon left small>mdi-clock</v-icon>
                      {{ turnoSeleccionado?.hora }}
                    </v-chip>
                  </div>
                </v-col>
              </v-row>
            </v-alert>

            <v-alert
              v-if="requiereSeleccionModalidad"
              color="info"
              outlined
              dense
              class="mb-6"
              prominent
            >
              <div class="text-subtitle-1 font-weight-bold mb-3">
                <v-icon left color="info">mdi-information</v-icon>
                Seleccione la modalidad del turno
              </div>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-btn
                    block
                    large
                    :color="
                      seleccionaVideoConsulta === false
                        ? 'success'
                        : 'grey lighten-2'
                    "
                    :dark="seleccionaVideoConsulta === false"
                    @click="seleccionaVideoConsulta = false"
                    elevation="2"
                    class="modalidad-btn"
                  >
                    <v-icon left>mdi-walk</v-icon>
                    Turno Presencial
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                    block
                    large
                    :color="
                      seleccionaVideoConsulta === true
                        ? 'purple'
                        : 'grey lighten-2'
                    "
                    :dark="seleccionaVideoConsulta === true"
                    @click="seleccionaVideoConsulta = true"
                    elevation="2"
                    class="modalidad-btn"
                  >
                    <v-icon left>mdi-video</v-icon>
                    Videoconsulta
                  </v-btn>
                </v-col>
              </v-row>
            </v-alert>

            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="paciente.dni"
                  label="Número de Documento *"
                  prepend-icon="mdi-card-account-details"
                  :rules="requiredRules"
                  required
                  maxlength="9"
                  @keypress="onlyNumber"
                  outlined
                  color="primary"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="paciente.apellidos"
                  label="Apellidos *"
                  prepend-icon="mdi-account"
                  :rules="requiredRules"
                  required
                  maxlength="50"
                  @blur="upper('apellidos')"
                  outlined
                  color="primary"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="paciente.nombres"
                  label="Nombres *"
                  prepend-icon="mdi-account"
                  :rules="requiredRules"
                  required
                  maxlength="50"
                  @blur="upper('nombres')"
                  outlined
                  color="primary"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="paciente.mail"
                  label="Email *"
                  prepend-icon="mdi-email"
                  :rules="emailRequiredRules"
                  required
                  maxlength="80"
                  outlined
                  color="primary"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="paciente.celular"
                  label="Celular"
                  prepend-icon="mdi-cellphone"
                  maxlength="50"
                  outlined
                  color="primary"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6">
                <v-select
                  :items="sexo"
                  v-model="paciente.sexo"
                  label="Sexo"
                  prepend-icon="mdi-gender-male-female"
                  outlined
                  color="primary"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="paciente.fechaNac"
                  label="Fecha de Nacimiento"
                  prepend-icon="mdi-calendar"
                  type="date"
                  outlined
                  color="primary"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-alert color="info" text dense class="mt-2">
              <v-icon left small>mdi-information</v-icon>
              Los campos marcados con * son obligatorios
            </v-alert>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              large
              @click="show = false"
              :disabled="guardando"
            >
              <v-icon left>mdi-close</v-icon>
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              :disabled="!valid || guardando"
              :loading="guardando"
              @click="guardarTurno"
              large
              elevation="2"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Confirmar Turno
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Modal de pago con countdown -->
    <v-dialog v-model="mostrarModalPago" max-width="480" persistent>
      <v-card class="pa-6 text-center">
        <v-icon size="60" color="primary" class="mb-3"
          >mdi-credit-card-outline</v-icon
        >
        <h2 class="text-h6 font-weight-bold mb-2">
          ¡Tu turno está casi confirmado! 🎾
        </h2>
        <p class="text-body-2 grey--text text--darken-1 mb-2">
          Para completar la reserva, necesitás abonar el turno a través de
          Mercado Pago.
        </p>
        <v-alert type="warning" dense text class="mb-3">
          Tenés <strong>{{ contadorTexto }}</strong> para realizar el pago. Si
          no se acredita en ese tiempo, la reserva se liberará automáticamente.
        </v-alert>
        <p class="caption grey--text mb-4">
          Serás redirigido a la plataforma de pago seguro de Mercado Pago.
        </p>
        <v-btn color="primary" large block rounded @click="irAPagar">
          <v-icon left>mdi-credit-card</v-icon>
          Ir a pagar ahora
        </v-btn>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.modalidad-btn {
  transition: all 0.3s;
}

.modalidad-btn:hover {
  transform: translateY(-2px);
}

/* Asegurar que el contenido del modal sea scrolleable en móviles */
::v-deep .v-dialog {
  overflow-y: auto !important;
}

/* En desktop, prevenir scroll del body cuando el modal está abierto */
@media (min-width: 600px) {
  ::v-deep .v-dialog {
    overflow-y: hidden !important;
  }

  ::v-deep .v-dialog > .v-card {
    overflow-y: auto !important;
    max-height: 90vh !important;
  }
}
</style>

<script>
import axios from "../axios-auth.js";

export default {
  name: "ModalDatosPaciente",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    turnoSeleccionado: {
      type: Object,
      default: null,
    },
    idProfesional: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      valid: false,
      guardando: false,
      mostrarModalPago: false,
      linkPago: "",
      segundosRestantes: 300,
      intervalContador: null,
      seleccionaVideoConsulta: null,
      paciente: {
        dni: "",
        apellidos: "",
        nombres: "",
        mail: "",
        celular: "",
        sexo: null,
        fechaNac: null,
      },
      sexo: ["FEMENINO", "MASCULINO", "OTRO"],
      requiredRules: [(v) => !!v || "Campo obligatorio"],
      emailRequiredRules: [
        (v) => !!v || "Campo obligatorio",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Email inválido",
      ],
      emailRules: [
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "Email inválido",
      ],
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.limpiarFormulario();
          this.$emit("close");
        }
      },
    },
    contadorTexto() {
      const m = Math.floor(this.segundosRestantes / 60);
      const s = this.segundosRestantes % 60;
      return `${m}:${s.toString().padStart(2, "0")}`;
    },
    requiereSeleccionModalidad() {
      // Si el tipoTurno es 2 o 3, el paciente debe elegir modalidad
      return [2, 3].includes(this.turnoSeleccionado?.tipoTurno);
    },
    textoConfirmacion() {
      if (this.seleccionaVideoConsulta === null) {
        return "¿Desea confirmar la reserva del turno?";
      } else if (this.seleccionaVideoConsulta === false) {
        return "¿Desea confirmar el turno presencial?";
      } else {
        return "¿Desea confirmar el turno de videoconsulta?";
      }
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // Resetear validaciones cuando se abre el modal
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.resetValidation();
          }
        });
      }
    },
  },
  methods: {
    iniciarContador() {
      this.segundosRestantes = 300;
      clearInterval(this.intervalContador);
      this.intervalContador = setInterval(() => {
        this.segundosRestantes--;
        if (this.segundosRestantes <= 0) {
          clearInterval(this.intervalContador);
          this.mostrarModalPago = false;
          this.show = false;
          this.$emit("turnoGuardado");
        }
      }, 1000);
    },
    irAPagar() {
      clearInterval(this.intervalContador);
      this.mostrarModalPago = false;
      this.show = false;
      this.$emit("turnoGuardado");
      window.open(this.linkPago, "_blank");
    },
    onlyNumber(event) {
      const keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    upper(campo) {
      if (this.paciente[campo]) {
        this.paciente[campo] = this.paciente[campo].toUpperCase();
      }
    },
    limpiarFormulario() {
      this.paciente = {
        dni: "",
        apellidos: "",
        nombres: "",
        mail: "",
        celular: "",
        sexo: null,
        fechaNac: null,
      };
      this.seleccionaVideoConsulta = null;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    guardarTurno() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$swal({
        title: "Confirmar Turno",
        text: this.textoConfirmacion,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.enviarTurno();
        }
      });
    },
    enviarTurno() {
      const datosTurno = {
        idInstitucion: this.$store.state.idInstitucion,
        dniPaciente: this.paciente.dni,
        apellidoPaciente: this.paciente.apellidos,
        nombrePaciente: this.paciente.nombres,
        fechaNacimientoString: this.paciente.fechaNac,
        sexo: this.paciente.sexo,
        celular: this.paciente.celular,
        email: this.paciente.mail,
        fechaTurnoString: this.turnoSeleccionado.fechaTurnoString,
        horaInicioString: this.turnoSeleccionado.hora,
        duracionTurno: this.turnoSeleccionado.tiempoTurno || 15,
        idObraSocial: 0,
        idProfesional: this.idProfesional,
        estadoTurno: 1,
        esWeb: true,
        seleccionaVideoConsulta: this.seleccionaVideoConsulta,
      };

      this.guardando = true;

      axios
        .post("/PortalPublico/GuardarTurno", datosTurno)
        .then((response) => {
          if (response.data === "Turnos Existentes") {
            this.$swal.fire({
              icon: "error",
              title: "El turno ya no está disponible",
              text: "Por favor seleccione otro horario",
              showConfirmButton: true,
            });
          } else if (response.data === "Reservado") {
            this.$swal.fire({
              icon: "error",
              title: "El turno acaba de ser tomado",
              text: "Por favor seleccione otro horario",
              showConfirmButton: true,
            });
          } else if (
            response.data &&
            typeof response.data === "object" &&
            response.data.link
          ) {
            // El turno requiere pago — mostrar modal con countdown
            // NO cerrar este modal todavía, el v-dialog de pago está dentro
            this.linkPago = response.data.link;
            this.mostrarModalPago = true;
            this.iniciarContador();
            // No emitir turnoGuardado ni cerrar hasta que el usuario pague o expire
          } else {
            // Turno reservado sin pago
            this.$swal.fire({
              icon: "success",
              title: "¡Turno reservado exitosamente!",
              text: "Recibirá un email de confirmación. Revise por favor su correo no deseado o spam.",
              showConfirmButton: false,
              timer: 3000,
            });
            this.show = false;
            this.$emit("turnoGuardado");
          }
        })
        .catch((error) => {
          console.error("Error al guardar turno:", error);
          this.$swal.fire({
            icon: "error",
            title: "Error al reservar el turno",
            text: "Por favor intente nuevamente",
            showConfirmButton: true,
          });
        })
        .finally(() => {
          this.guardando = false;
        });
    },
  },
};
</script>
